@charset "UTF-8";

/* src/app/layout/components/app.menuitem.scss */
.layout-menuitem-badge {
  position: absolute;
  top: 50%;
  left: 70%;
  transform: translateY(-100%) translateX(-50%);
  width: 14px;
  height: 14px;
  min-width: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px !important;
  font-weight: 600;
  border-radius: 50% !important;
  background:
    linear-gradient(
      135deg,
      #ff6b6b,
      #ee5a52);
  color: white;
  border: none;
  z-index: 1000;
  box-sizing: border-box;
  box-shadow: 0 2px 4px rgba(255, 107, 107, 0.3);
  padding: 0 !important;
  line-height: 1;
  transition: all 0.3s ease-out;
  overflow: hidden;
}
.ef-menuitem-badge-on {
  background:
    linear-gradient(
      135deg,
      #ff6b6b,
      #ee5a52) !important;
  color: white !important;
  display: flex !important;
}
.ef-menuitem-badge-off {
  display: none !important;
}
.layout-checkup-menuitem-badge {
  position: absolute;
  top: 55%;
  left: 70%;
  transform: translateY(-100%) translateX(-50%);
  width: 15px;
  height: 15px;
  min-width: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px !important;
  font-weight: 600;
  border-radius: 50% !important;
  background:
    linear-gradient(
      135deg,
      #ff6b6b,
      #ee5a52);
  color: white;
  border: none;
  z-index: 1000;
  box-sizing: border-box;
  box-shadow: 0 2px 4px rgba(255, 107, 107, 0.3);
  padding: 0 !important;
  line-height: 1;
  transition: all 0.3s ease-out;
  overflow: hidden;
}
.ef-menuitem-checkup-badge-on {
  background:
    linear-gradient(
      135deg,
      #ff6b6b,
      #ee5a52) !important;
  color: white !important;
  display: flex !important;
}
.ef-menuitem-checkup-badge-off {
  display: none !important;
}
:host ::ng-deep a {
  position: relative !important;
  overflow: visible !important;
}
:host ::ng-deep .layout-menuitem {
  position: relative !important;
  overflow: visible !important;
}
:host ::ng-deep .layout-menu {
  overflow: visible !important;
}
:host ::ng-deep .layout-menu-container {
  overflow: visible !important;
}
:host ::ng-deep .layout-sidebar {
  overflow: visible !important;
}
:host ::ng-deep .layout-sidebar .layout-menu-container {
  overflow-x: visible !important;
  overflow-y: auto !important;
}
:host ::ng-deep .layout-menuitem:hover .layout-menuitem-badge,
:host ::ng-deep a:hover .layout-menuitem-badge,
:host ::ng-deep .layout-menuitem-link:hover .layout-menuitem-badge,
:host ::ng-deep .p-menuitem:hover .layout-menuitem-badge,
:host ::ng-deep .p-menuitem-link:hover .layout-menuitem-badge,
:host ::ng-deep .layout-menuitem:hover .layout-checkup-menuitem-badge,
:host ::ng-deep a:hover .layout-checkup-menuitem-badge,
:host ::ng-deep .layout-menuitem-link:hover .layout-checkup-menuitem-badge,
:host ::ng-deep .p-menuitem:hover .layout-checkup-menuitem-badge,
:host ::ng-deep .p-menuitem-link:hover .layout-checkup-menuitem-badge {
  transform: translateY(-100%) translateX(-50%) scale(1.5);
  font-size: 8px !important;
  padding: 1px 3px !important;
  min-width: 12px;
  height: 12px;
  width: auto;
  border-radius: 6px !important;
  box-shadow: 0 3px 6px rgba(255, 107, 107, 0.4);
}
@keyframes ai-expert-border-shimmer {
  to {
    transform: rotate(360deg);
  }
}
@keyframes ai-expert-border-glow {
  0%, 100% {
    opacity: 0.88;
  }
  50% {
    opacity: 1;
  }
}
a.ai-expert-menuitem {
  position: relative !important;
  isolation: isolate;
  overflow: visible !important;
  background-color: transparent !important;
}
a.ai-expert-menuitem::before {
  content: "";
  position: absolute;
  inset: -2px;
  border-radius: 50%;
  background:
    conic-gradient(
      from 0deg,
      var(--p-emerald-500, #10b981),
      color-mix(in srgb, var(--p-emerald-500, #10b981) 55%, var(--p-yellow-400, #facc15)),
      var(--p-yellow-400, #facc15),
      color-mix(in srgb, var(--p-yellow-400, #facc15) 50%, var(--p-primary-500, #337AB7)),
      var(--p-primary-500, #337AB7),
      color-mix(in srgb, var(--p-primary-500, #337AB7) 55%, var(--p-emerald-500, #10b981)),
      var(--p-emerald-500, #10b981));
  animation: ai-expert-border-shimmer 10s linear infinite, ai-expert-border-glow 4s ease-in-out infinite;
  z-index: -2;
  pointer-events: none;
}
a.ai-expert-menuitem::after {
  content: "";
  position: absolute;
  inset: 2px;
  border-radius: 50%;
  background: var(--p-surface-700, #374151);
  z-index: -1;
  pointer-events: none;
}
a.ai-expert-menuitem .layout-menuitem-icon,
a.ai-expert-menuitem .layout-menuitem-text {
  position: relative;
  z-index: 1;
}
a.ai-expert-menuitem:hover {
  background-color: transparent !important;
  filter: brightness(1.08);
}
a.ai-expert-menuitem:hover::before {
  animation-duration: 7s, 3s;
}
@media (prefers-reduced-motion: reduce) {
  a.ai-expert-menuitem::before {
    animation: none;
    background: var(--p-emerald-500, #10b981);
  }
}
/*# sourceMappingURL=app.menuitem.css.map */
